import { getEventName } from '../utils/eventHelpers';
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTopEvents } from '../api/api';
import { EventSnapshot, Market, Outcome, TopEventItem } from '../api/types';
import { TopEventsCard } from './widgets/TopEventsCard';
import { TOURNAMENT_ID_MAP } from '../constants/tipico_menu';
import { BetItem } from './BettingSlipDrawer';
import { generateBetItemId } from '../utils/ticketHelpers';

interface MobileTopEventsSectionProps {
  bets: BetItem[];
  onAddBet: (bet: BetItem) => void;
  onRemoveBet: (betId: string) => void;
}

export const MobileTopEventsSection: React.FC<MobileTopEventsSectionProps> = ({ bets, onAddBet, onRemoveBet }) => {
  const [events, setEvents] = useState<TopEventItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    const fetchEvents = async () => {
      try {
        const res = await getTopEvents({ limit: 10 });
        if (mounted && res && res.items) {
          setEvents(res.items);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchEvents();
    return () => { mounted = false; };
  }, []);

  const topEvents = useMemo(() => {
    return events.slice(0, 6);
  }, [events]);

  const handleOddsClick = (ev: EventSnapshot, market: Market, outcome: Outcome, tippLabel: string) => {
    const betId = generateBetItemId(ev.event_id, market.market_id, outcome.outcome_id, market.specifiers);
    const isSel = bets.some((b) => b.id === betId);
    if (isSel) {
      onRemoveBet(betId);
    } else {
      onAddBet({
        id: betId,
        matchId: 0,
        matchName: getEventName(ev.event),
        betType: tippLabel === 'Heimsieg' ? 'home' : tippLabel === 'Unentschieden' ? 'draw' : 'away',
        tippLabel: tippLabel,
        odds: outcome.odds,
        eventId: ev.event_id,
        marketId: market.market_id,
        outcomeId: outcome.outcome_id,
        outcomeName: (outcome as any).player_name || (outcome as any).playerName || outcome.name,
        specifiers: market.specifiers
          ? typeof market.specifiers === 'string'
            ? market.specifiers
            : Object.entries(market.specifiers).map(([k, v]) => `${k}=${v}`).join('|')
          : undefined
      });
    }
  };

  const isSelected = (eventId: string, marketId: string, outcomeId: string, specifiers?: Record<string, string>) => {
    const betId = generateBetItemId(eventId, marketId, outcomeId, specifiers);
    return bets.some((b) => b.id === betId);
  };

  const formatTime = (iso: string) => {
    return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  };

  if (topEvents.length === 0) return null;

  return (
    <div className="bg-white pt-4 pb-2 mb-2 shadow-sm rounded-xl">

      <div className="flex gap-4 overflow-x-auto scrollbar-hide snap-x px-3 pb-2">
        {topEvents.map(ev => (
          <div key={ev.event_id} className="snap-start flex-shrink-0">
            <TopEventsCard 
              event={ev} 
              onOddsClick={handleOddsClick} 
              isSelected={isSelected} 
              formatTime={formatTime} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};
export default MobileTopEventsSection;
